import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 24px;
  background-color: #fff;
  width: 100%;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 1px 3px #0000001f;
  border-radius: 4px;
  color: '#2b2727';
  .procedure-detail-bloc-title {
    font-size: 18px;
    font-weight: bold;
    color: #2b2727;
    margin-bottom: 32px;
  }
  .formEl {
    width: 25%;
    margin-bottom: 5px;
    font-weight: bold;
  }
  .form-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
  }
  .textBox {
    width: 100%;
    margin-bottom: 33px;
  }
  .checkbox-form-label {
    margin-right: 17px;
  }
  .other-form-wrapper {
    display: flex;
    flex-direction: column;
    padding: 5px;
    margin-top: 19px;
  }
  .is-insured-sued {
    display: flex;
    align-items: center;
  }
  .checkbox-form-label {
    font-size: 13px;
  }

  // material ui native classes
  .MuiFormLabel-root,
  .MuiFormControlLabel-label {
    font-size: 13px;
  }
  .MuiInputLabel-shrink {
    color: #00000061;
  }
  .MuiFormLabel-root.Mui-focused {
    color: rgba(9, 122, 194, 1);
  }
  .MuiRadio-colorPrimary {
    width: 18px;
    height: 18px;
    margin: 0 8px;
  }
  .sued-party-title {
    margin-bottom: 5px;
  }
`;
